import React from 'react';
import { useTranslation } from 'react-i18next';
import '../layout/sec1.css';
import '../../root.css';
import ic from '../../asserts/ic.png';
import ic1 from '../../asserts/ic1.png';
import sec1img from '../../asserts/sec1img.png';
import Btn1 from '../common/btn1';

const Sec1 = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className='sec1'>
                <div className='sec1-div'>
                    <div className='sec1-head'>
                        <h1 className='sec1-title'>
                            {t('sec1_title_discover')}
                        </h1>
                        <h1 className='sec1-title sec1-title1'>
                            {t('sec1_title_unforgettable')}
                        </h1>
                        <h1 className='sec1-title'>
                            {t('sec1_title_experience')}
                        </h1>
                    </div>

                    <p className='sec1-text'>
                        {t('sec1_text')}
                    </p>

                    <div className='sec1-btns'>
                        <Btn1 b='btn1' btntt={t('sec1_btn_started')} ic={ic} />
                        <Btn1 b='btn2' btntt={t('sec1_btn_demo')} ic={ic1} />
                    </div>

                    <div className='sec1-stats'>
                        <div className='sec1-card'>
                            <h3 className='sec1-card-num'>10K+</h3>
                            <p className='sec1-card-text'>{t('sec1_stat_learners')}</p>
                        </div>

                        <div className='sec1-card'>
                            <h3 className='sec1-card-num'>500+</h3>
                            <p className='sec1-card-text'>{t('sec1_stat_lessons')}</p>
                        </div>

                        <div className='sec1-card'>
                            <h3 className='sec1-card-num'>95%</h3>
                            <p className='sec1-card-text'>{t('sec1_stat_rate')}</p>
                        </div>
                    </div>
                </div>

                <div className='sec1-img-div'>
                    <img className='sec1-img' src={sec1img} alt="Arabic Learning Hero" />
                </div>
            </section>
        </>
    );
};

export default Sec1;